module.exports = __webpack_public_path__ + "static/media/banner.bff13020.jpg";